import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';

import {TranslateService} from '@ngx-translate/core';
import {EmailValidator} from '../../../../../model/email-validator';
import {UserManagementService} from '../../../../../services/apiServices/business/user-management.service';
import {CustomerGroup} from '../../../../../model/customer-group';
import {SelectItem} from 'primeng/api';
import {FileSaverService} from 'ngx-filesaver';
import {CommonService} from '../../../../../services/apiServices/business/common.service';

@Component({
  selector: 'app-import-users',
  templateUrl: './import-users.component.html',
  styleUrls: ['./import-users.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ImportUsersComponent implements OnInit {
  constructor(private translate: TranslateService, private commonService: CommonService,
              private fileSaverService: FileSaverService,
              private userManagementService: UserManagementService) {
  }
  @Input()
  errorMessage;
  @Input()
  customerId;

  @Input()
  groups: CustomerGroup[];
  roles: SelectItem[];
  operations: SelectItem[];
  locales: SelectItem[];
  columns: any[];
  users: any[];
  fileImportedMessage: string;
  fileNotImportedMessage: string;
  successTitle: string;
  failureTitle: string;
  messages: string[];


  ngOnInit(): void {
    this.roles = [
      {label: 'Utilisateur', value: 'utilisateur'},
      {label: 'Superviseur', value: 'supervisor'}
    ];
    this.locales = [
      {label: 'Français', value: 'FR'},
      {label: 'Anglais', value: 'EN'}
    ];
    this.operations = [
      {label: 'Ajout', value: 'ADD'},
      {label: 'MAJ', value: 'UPDATE'},
      {label: 'Supp.', value: 'DELETE'}
    ];
    this.columns = [
      {required: true, name: 'action', values: ['Action', 'action', 'ACTION']},
      {required: true, name: 'userName', values: ['ID', 'userName', 'IDENTIFIANT']},
      {required: true, name: 'role', values: ['Rôle', 'role', 'ROLE']},
      {required: true, name: 'groupId', values: ['Groupe', 'Group', 'GROUPE']},
      {required: true, name: 'firstName', values: ['First Name', 'prénom', 'PRENOM']},
      {required: true, name: 'lastName', values: ['Last Name', 'Nom', 'NOM']},
      {required: true, name: 'lang', values: ['Langue', 'language', 'locale', 'LANGUE']},
      {required: true, name: 'email', values: ['Email', 'E-mail', 'mail', 'courriel', 'EMAIL']}
    ];
    this.translate.get('TOASTER.SUCCESS_MESSAGE_TITLE').subscribe((title: string) => {
      this.successTitle = title;
    });
    this.translate.get('TOASTER.ERROR_MESSAGE_TITLE').subscribe((title: string) => {
      this.failureTitle = title;
    });
    this.translate.get('TOASTER.USER_CSV_FILE_IMPORTED').subscribe( msg => {
      this.fileImportedMessage = msg;
    });
    this.translate.get('TOASTER.USER_CSV_FILE_NOT_IMPORTED').subscribe( msg => {
      this.fileNotImportedMessage = msg;
    });
  }

  public importUsers(): void {
    this.userManagementService.importUsers(this.users).subscribe(response => {
      if (response && response.bOK) {
        this.commonService.addToast({
          life: 3000,
          severity: 'success',
          summary: this.successTitle,
          detail: this.fileImportedMessage
        });

        this.messages = [];
        if (response.datas) {
          var ko = 0;
          var total = response.datas.length;
          for (const line of response.datas) {
            const [user, operation, success] = line;
            if(success === "false") {
              ko+=1;
              if(operation === "DOUBLON"){
                this.messages.push("L'opération ADD sur l'utilisateur "+user+ " est en échec car cette utilisateur existe déjà dans le LDAP pour ce CL.")
              }
              else{
                this.messages.push("L'opération "+operation+ " sur l'utilisateur "+user+ " est en échec.");
              }
            }
            else if (operation === "DOUBLON"){
              ko+=1;
              this.messages.push("L'opération ADD sur l'utilisateur "+user+ " est en échec car cette utilisateur existe déjà dans le LDAP pour ce CL.")
            }
          }
          this.messages.unshift(total + " opérations effectuées dont "+ko+" en échecs.")
        }
      }
      else {
        this.commonService.addToast({
          life: 5000,
          severity: 'error',
          summary: this.failureTitle,
          detail: this.fileNotImportedMessage
        });
        this.messages = [];
        if (response.datas) {
          for (const line in response.datas) {
            if (response.datas.hasOwnProperty(line)) {
              const lineNumber = line.replace('Line_', '');
              const errors = response.datas[line];
              for (const error of errors) {
                this.messages.push(lineNumber + ' : ' + this.translate.instant('GROUPS.' + error));
              }
            }
          }
          this.messages.sort((a, b) => {
            return a.localeCompare(b);
          });
        }
      }
    });
  }

  public getImportTemplate(): void {
    const csvContent =
        'ACTION;'
      + 'IDENTIFIANT;'
      + 'PRENOM;'
      + 'NOM;'
      + 'GROUPE;'
      + 'ROLE;'
      + 'EMAIL;'
      + 'LANGUE'
    ;
    const blob = new Blob([csvContent], {type: 'application/csv'});
    this.fileSaverService.save(blob, 'import-users.csv');
  }

  onFileLoad(textFromFileLoaded) {
    this.errorMessage = undefined;
    const allTextLines = textFromFileLoaded.split(/\r\n|\r|\n/);
    const headers = allTextLines[0].split(/[;,]/);
    const fileCols = [];
    for (const col of this.columns) {
      let found = false;
      let index = 0;
      for (const header of headers) {
        for (const label of col.values) {
          if (label.toLowerCase() === header.toLowerCase()) {
            found = true;
            fileCols.push({
              position: index,
              required: col.required,
              col: col.name
            });
            break;
          }
        }
        index++;
      }

      if (!found) {
        if (col.required) {
          if (col.value) {
            fileCols.push({
              position: headers.length,
              required: col.required,
              col: col.name,
              value: col.value
            });
          } else {
            this.translate.get('COMMON.MISSING_COLUMN').subscribe(msg => {
              this.errorMessage = msg + ':' + col.name;
            });
          }
        }
      }
    }
    this.users = [];
    for (let i = 1; i < allTextLines.length; i++) {
      const data = allTextLines[i].split(/[;]/);
      if (data.length < 2) {
        continue;
      }
      const user: any = {
        customerID: this.customerId,
      };
      for (const fileCol of fileCols) {
        let value = data[fileCol.position];
        if (fileCol.required && !value) {
          this.translate.get('COMMON.MISSING_COLUMN').subscribe(msg => {
            this.errorMessage = 'ligne: ' + i + ' ' + msg + ': ' + fileCol.col;
            return;
          });
        }
        if (!value && fileCol.value) {
          value = fileCol.value;
        }
        switch (fileCol.col) {
          case 'action': {
            if (value.toUpperCase() === 'ADD' || value.toUpperCase() === 'AJOUTER') {
              user.action = 'ADD';
            }
            else if ( value.toUpperCase() === 'UPDATE' || value.toUpperCase() === 'METTRE A JOUR') {
              user.action = 'UPDATE';
            }
            else if (value.toUpperCase() === 'DELETE' || value.toUpperCase() === 'SUPPRIMER') {
              user.action = 'DELETE';
            }
            else {
              this.translate.get('COMMON.UNSUPPORTED_OPERATION').subscribe(msg => {
                this.errorMessage = msg + ' : ' + value;
                return;
              });
            }
            break;
          }
          case 'userName': {
            user.userName = value;
            break;
          }
          case 'role': {
            if (value.toUpperCase() !== 'USER' && value.toUpperCase() !== 'UTILISATEUR'
              && value.toUpperCase() !== 'SUPERVISOR' && value.toUpperCase() !== 'SUPERVISEUR') {
              this.translate.get('COMMON.UNSUPPORTED_ROLE').subscribe(msg => {
                this.errorMessage = msg + ' : ' + value;
                return;
              });
            }
            if (value.toUpperCase() === 'USER' || value.toUpperCase() === 'UTILISATEUR') {
              user.role = 'utilisateur';
            } else if (value.toUpperCase() === 'SUPERVISOR' || value.toUpperCase() === 'SUPERVISEUR') {
              user.role = 'supervisor';
            }
            break;
          }
          case 'firstName': {
            user.firstName = value.toUpperCase();
            break;
          }
          case 'lastName': {
            user.lastName = value.toUpperCase();
            break;
          }
          case 'groupId': {
            if (this.groupExists(value)) {
              user.groupId = value;
            }
            else {
              this.translate.get('COMMON.UNSUPPORTED_LANG').subscribe(msg => {
                this.errorMessage = msg + ' : ' + value;
                return;
              });
            }
            break;
          }
          case 'lang': {
            if (value.toUpperCase() !== 'FR' && value.toUpperCase() !== 'FRANCAIS'
              && value.toUpperCase() !== 'EN' && value.toUpperCase() !== 'ENGLISH') {
              this.translate.get('COMMON.UNSUPPORTED_LANG').subscribe(msg => {
                this.errorMessage = msg + ' : ' + value;
                return;
              });
            }
            if (value.toUpperCase() === 'FR' || value.toUpperCase() === 'FRANCAIS') {
              user.defaultLocale = 'FR';
            } else {
              user.defaultLocale = 'EN';
            }
            break;
          }
          case 'email': {
            if (!EmailValidator.emailIsValid(value)) {
              this.translate.get('COMMON.INVALID_MAIL').subscribe(msg => {
                this.errorMessage = msg + ' : ' + value;
                return;
              });
            }
            user.email = value;
            break;
          }
        }
      }
      this.users.push(user);
    }
  }
  groupExists(groupId: string) {
    for (const group of this.groups) {
      if (group.sGrpUserID === groupId) {
        return true;
      }
    }
    return false;
  }
  checkFileContent(event, csvFileUpload) {
    const files = csvFileUpload.files;
    if (files && files.length) {
      const fileToRead = files[0];
      const fileReader = new FileReader();
      fileReader.readAsText(fileToRead, 'UTF-8');
      fileReader.onloadend = () => {
        this.onFileLoad(fileReader.result);
        csvFileUpload.clear();
      };
    }

  }
}
